<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import AppLogo from '@/components/AppLogo.vue';
import RobotsNoIndexHead from '@/components/seo/RobotsNoIndexHead.vue';
import { useTranslations } from '@/composables/useTranslations';
import { dashboard } from '@/routes';

const { t } = useTranslations();

defineProps<{
    title?: string;
    description?: string;
}>();
</script>

<template>
    <RobotsNoIndexHead />

    <div
        class="relative grid h-dvh flex-col items-center justify-center bg-background px-8 sm:px-0 lg:max-w-none lg:grid-cols-2 lg:px-0"
    >
        <div
            class="relative hidden h-full flex-col overflow-hidden border-border bg-background p-10 text-foreground lg:flex lg:border-r"
        >
            <Link
                :href="dashboard.url()"
                prefetch
                class="relative z-10 inline-flex max-w-full shrink-0 items-center rounded-md text-lg font-medium text-foreground ring-offset-background outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                :aria-label="t('tools.nav.home', 'Home')"
            >
                <AppLogo size="lg" />
            </Link>

            <div
                class="flex min-h-0 flex-1 flex-col items-center justify-center py-6"
                aria-hidden="true"
            >
                <img
                    src="/images/auth-panel-illustration.svg"
                    alt=""
                    width="780"
                    height="900"
                    loading="lazy"
                    decoding="async"
                    class="pointer-events-none max-h-full w-full max-w-xl object-contain select-none"
                />
            </div>

            <p
                class="relative z-10 mt-auto max-w-sm shrink-0 text-sm leading-relaxed text-muted-foreground"
            >
                {{ t('auth.split_layout_tagline', '') }}
            </p>
        </div>
        <div class="bg-background lg:p-8">
            <div
                class="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]"
            >
                <div class="flex flex-col space-y-2 text-center">
                    <h1 class="text-xl font-medium tracking-tight" v-if="title">
                        {{ title }}
                    </h1>
                    <p class="text-sm text-muted-foreground" v-if="description">
                        {{ description }}
                    </p>
                </div>
                <slot />
            </div>
        </div>
    </div>
</template>
